var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state.loaded)?_c('div',[_c('div',{staticClass:"subheading font-weight-medium pb-3"},[_vm._v(_vm._s(_vm.subject))]),_c('div',{staticClass:"pt-3 pl-3 pb-3 pr-3 email-content",domProps:{"innerHTML":_vm._s(_vm.body)}})]):_c('our-loading-indicator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }